import http from "../http-common";

class ProjectDataService {

    getProjects(managing_tenant_id, customer_id, ignore_date, updated_from, updated_to, generate_report) {
        return http.get(`/projects/getProjects?customerId=${customer_id}&managingTenantId=${managing_tenant_id}&ignoreDate=${ignore_date}&updatedFrom=${updated_from}&updatedTo=${updated_to}&generateReport=${generate_report}`, { withCredentials: true });
    }

    generateReport(managing_tenant_id, customer_id, ignore_date, updated_from, updated_to, generate_report) {
        return http.get(`/projects/getProjects?customerId=${customer_id}&managingTenantId=${managing_tenant_id}&ignoreDate=${ignore_date}&updatedFrom=${updated_from}&updatedTo=${updated_to}&generateReport=${generate_report}`, { withCredentials: true , 'Accept': 'application/pdf', responseType: 'blob'});
    }

    getSpecificProject(project_id) {
        return http.get(`/projects/getSpecificProject?projectId=${project_id}`, { withCredentials: true });
    }

    addProject(data) {
        return http.post(`/projects/addProject`, data, { withCredentials: true });
    }

    editProject(data) {
        return http.post(`/projects/editProject`, data, { withCredentials: true });
    }

    deleteProject(project_id) {
        return http.delete(`/projects/deleteProject?projectId=${project_id}`, { withCredentials: true });
    }

}

export default new ProjectDataService();